export const ServiceStatus = {
	confirmed: 'confirmed',
	denied: 'denied',
	duplicated: 'duplicate',
	enrolled: 'enrolled',
	error: 'error',
	pendingConfirmation: 'pendingConfirmation',
	ok: 'ok',
	timeout: 'timeout',
};
export const ServiceNames = {
	adherence: 'adherence',
	copay: 'copay',
	fto: 'fto',
	activation: 'activation',
};
export const ConsentIDs = {
	tcpa: 'tcpa',
	hipaa: 'hipaa',
	transactional: 'transactional',
};
